import React from 'react'
import MaterialTable, { MTableToolbar }  from '@material-table/core'
import { isEmailValid } from '@auteco/utils/inputValidations'


const EmailsPage = ({ info, onUpdateEmail }) => {
  const formatedEmails = (data) => {
    const formated = data.split(',')
    let validate;
    if (formated.length > 1) {
      validate = formated.every(value => isEmailValid(value.trim()))
    } else {
      validate = isEmailValid(data) || data === ''
    }
    return validate
  }
  const columns = [
    {
      title: 'Código punto de venta',
      field: 'CODIGO_PUNTO_VENTA',
      editable: 'never',
      cellStyle: {
        color: '#E2A233',
      },
    },
    {
      title: 'Nombre punto de venta',
      field: 'NOMBRE_PUNTO_VENTA',
      editable: 'never',
      cellStyle: {
        color: '#2699FB',
      },
    },
    {
      title: 'Jefe',
      field: 'JEFE',
      editable: 'never',
    },
    {
      title: 'Correos (separados por coma)',
      field: 'CORREO',
      type: 'string',
      placeholder: 'Hola',
      validate: (rowData) =>
        formatedEmails(rowData.CORREO) ?
          true
          : { isValid: false, helperText: 'Correo invalido' }
    }
  ]
  return (
    <div>
      <MaterialTable
        title='Configuración correos'
        columns={columns}
        data={info}
        style={{
          color: '#5A5A5A',
          fontWeight: 600
        }}
        components={{
          Toolbar: (props) => (
            <div
              style={{
                background: '#FCFCFC',
                color: '#E2A233',
              }}
            >
              <MTableToolbar {...props} />
            </div>
          ),
        }}
        options={{
          showSelectAllCheckbox: false,
          selection: false,
          headerStyle: {
            backgroundColor: '#F6F6F6',
            color: '#161615',
            fontSize: '14px',
            fontWeight: 700,
            textAlign: 'center',
            padding: '0 10px'
          },
          actionsColumnIndex: -1,
        }}
        editable={{
          onRowUpdate: (newData) =>
            new Promise((resolve) => {
              onUpdateEmail(newData)
              resolve()
          }),
        }}
      />
    </div>
  )
}

export default EmailsPage